import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CarOrVanAvailability from './car-or-van-availability';
import CarOrVanAvailabilityDetail from './car-or-van-availability-detail';
import CarOrVanAvailabilityUpdate from './car-or-van-availability-update';
import CarOrVanAvailabilityDeleteDialog from './car-or-van-availability-delete-dialog';

const CarOrVanAvailabilityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CarOrVanAvailability />} />
    <Route path="new" element={<CarOrVanAvailabilityUpdate />} />
    <Route path=":id">
      <Route index element={<CarOrVanAvailabilityDetail />} />
      <Route path="edit" element={<CarOrVanAvailabilityUpdate />} />
      <Route path="delete" element={<CarOrVanAvailabilityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CarOrVanAvailabilityRoutes;
